import { post } from '../services/LeadApiService'
import { format } from 'date-fns'

export const state = {
  name: '',
  businessName: '',
  telephoneNumber: '',
  email: '',
  contactDate: '',
  contactTime: '',
  contactDateTime: '',
  status: '',
  callbackCreationAttempts: 0,
  reviewElectricity: false,
  reviewGas: false,
  reviewInsurance: false,
  reviewTelco: false,
  currentSupplier: '',
  maskCode: ''
}

// getters
export const getters = {
  displayDate: state => {
    const dateObject = new Date(state.contactDateTime)
    return state.contactTime + ' on ' + dateObject.getDate() + ' ' + dateObject.toLocaleString('en-uk', { month: 'long' })
  },
  formattedDate: state => {
    if (state.contactDateTime) return format(state.contactDateTime, "do 'of' MMMM")
  },
  formattedTime: state => {
    if (state.contactDateTime) return format(state.contactDateTime, 'HH:mm')
  },
  formattedTimeSuffixed: state => {
    if (state.contactDateTime) return `${format(state.contactDateTime, 'h:mmaaaaa')}m`
  }
}

// mutations
export const mutations = {
  UPDATE_CALLBACK_DATA: (state, data) => {
    Object.assign(state, data)
  },
  LEAD_CREATION_REQUEST: (state) => {
    state.status = 'loading'
    state.callbackCreationAttempts++
  },
  LEAD_CREATION_SUCCESS: (state) => {
    state.status = 'success'
    state.callbackCreationAttempts = 0
  },
  LEAD_CREATION_ERROR: (state) => {
    state.status = 'error'
  }
}

// actions
export const actions = {
  actionUpdateCallBackData ({ commit }, data) {
    if (data.contactDate && data.contactTime) {
      data.contactDateTime = data.contactDate + 'T' + data.contactTime
    }
    commit('UPDATE_CALLBACK_DATA', data)
  },
  actionCreateLead ({ commit, state, rootGetters }) {
    if (state.status === 'loading') { return }
    commit('LEAD_CREATION_REQUEST')

    const contactTime = state.contactDateTime ? format(state.contactDateTime, 'yyyy-MM-dd HH:mm') : ''

    const params = {
      name: state.name,
      business_name: state.businessName,
      telephone_number: state.telephoneNumber.replace('+44', '0'),
      email: state.email,
      contact_time: contactTime,
      notes: rootGetters.leadNotes,
      review_electricity: state.reviewElectricity,
      review_gas: state.reviewGas,
      review_insurance: state.reviewInsurance,
      review_telco: state.reviewTelco,
      current_supplier: state.currentSupplier,
      is_digital_journey: true,
      pGUID: state.maskCode === 'TST2' ? '0BBAC68D-B97C-4ABF-A836-793A6E83579B' : rootGetters.GUID, // Ensure CTM Eggplant test leads do not reach Salesforce
      pAccName: rootGetters.accountName,
      pPartner: rootGetters.partnerName,
      ga_client_id: window.ga && window.ga.getAll().length > 0 ? window.ga.getAll()[0].get('clientId') : '',
      ga_tracking_id: process.env.VUE_APP_UA_ID,
      mask_code: state.maskCode
    }

    return post(params)
      .then(apiResponse => {
        if (apiResponse.status === 201) {
          commit('LEAD_CREATION_SUCCESS')
          return apiResponse
        } else {
          throw apiResponse
        }
      })
      .catch(error => {
        commit('LEAD_CREATION_ERROR')
        throw error
      })
  }
}
